import { Injectable } from '@angular/core';
import { CityStreetEnGbInterface } from '@app/core/interfaces/city-street.en-gb.interface';
import { CivicNumberSuffixEnGbInterface } from '@app/core/interfaces/civic-number-suffix-en-gb.interface';
import { RequestService } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface CityStreetRequestInterface {
    civic_number: string;
    civic_number_suffix?: string;
    postal_code: string;
}

@Injectable({
    providedIn: 'root',
})
export class AddressService {

    constructor(private request: RequestService) {}

    public getCityStreet(postalCode: string, civicNumber: string): Observable<CityStreetEnGbInterface> {
        const payload = { address: { postal_code: postalCode, civic_number: civicNumber } };

        return this.request.post('en-gb/address-general/request/dutch-address-postcode_address', payload)
            .pipe(
                map(result => result.data),
                map((data: CityStreetEnGbInterface | false) => {
                    if (data === false) {
                        throw new Error('Postal Code & Civic Number combination invalid');
                    }
                    return data;
                }),
            );
    }

    public getCivicNumberSuffixes(postalCode: string, civicNumber: string)
        : Observable<CivicNumberSuffixEnGbInterface[]> {
        const payload = { address: { postal_code: postalCode, civic_number: civicNumber } };

        return this.request.post('en-gb/address-general/request/dutch-address-suffix', payload).pipe(
            map(result => result.data),
            map(data => data !== null ? data : { additions: [] }),
            map(data => data.additions),
            map((suffixes?: CivicNumberSuffixEnGbInterface[]) => {
                if (suffixes === null) {
                    suffixes = [];
                }
                return suffixes.filter(suffix => {
                    return suffix.civic_number_suffix !== null
                        && suffix.civic_number_suffix !== '';
                });
            }),
        );
    }
}
